module.exports = __webpack_public_path__ + "static/media/crisis-situations-large@2x.55204efb.png";